package devxertech.com.pages.dashboard

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.HomePageHeader
import devxertech.com.pages.dashboard.aboutUsSection.AboutUsSection
import devxertech.com.pages.dashboard.clientFeedbackSection.ClientFeedback
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.portFolioSection.PortfolioSection
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.pages.dashboard.serviceAndTechSection.ServicesSection
import devxertech.com.pages.dashboard.softwareDevelopmentSection.SoftwareDevelopment
import devxertech.com.pages.dashboard.teamOfferSection.TeamOfferSection
import devxertech.com.seo.PageMetadata
import devxertech.com.seo.PageSeo
import devxertech.com.theme.toSitePalette

@Page("/homepage")
@Composable
fun Dashboard(){
    PageMetadata(PageSeo.Home)
    val sitePalette = ColorMode.current.toSitePalette()
   val breakpoint = rememberBreakpoint()


    Column (modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)){
        HomePageHeader(
            mainHeadingAsH1 = rememberPageContext().route.path in setOf("/", "/homepage"),
            breakpoint = breakpoint,
            headingText = "Think Big We Make it Possible!",
            descriptionText = "Your Ideas will get their desired form- Website, Mobile app or" +
                    " anything Technical,",
            descriptionTextAddition = "let Devxer Technologies lead the way"
        )
        AboutUsSection(breakpoint)
        ServicesSection(breakpoint )
        TeamOfferSection()
        SoftwareDevelopment(breakpoint)
        PortfolioSection()
        ClientFeedback(breakpoint)
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}






